import { putTelephoneNumberQuery } from '../graphql/queries/multibss/telephoney.query';
import { ApiResponse, query } from './api';
import { ChangePhoneNumberSuccess } from './telephoney.types';

export interface TelephonyApiInterface {
  changePhoneNumber(
    billingCustomerId: string,
    assignedProductId: string
  ): Promise<ApiResponse<ChangePhoneNumberSuccess>>;
}

export const TelephonyApi: TelephonyApiInterface = {
  async changePhoneNumber(
    billingCustomerId: string,
    assignedProductId: string
  ): Promise<ApiResponse<ChangePhoneNumberSuccess>> {
    const response = await query<{ putTelephoneNumber: ChangePhoneNumberSuccess }>({
      query: putTelephoneNumberQuery,
      variables: { billingCustomerId, assignedProductId },
      name: 'putTelephoneNumber',
    });

    return {
      data: response.putTelephoneNumber,
    };
  },
};
